import React from "react";
import { BookOpen } from "lucide-react";
import SacredChatPage from "./SacredChatPage";
import { PLAYLISTS } from "@/lib/tracks";

const LESSON_TOPICS = {
  fr: [
    "L'Ajusteur de Pensée",
    "Havona (l'univers central)",
    "Les 7 superunivers",
    "Michel de Nébadon",
    "La Trinité du Paradis",
    "Les 7 Esprits Maîtres",
    "La vie de Jésus (Partie IV)",
    "Lucifer et la rébellion",
    "Les Morontia (survie)",
    "Le Suprême et l'Ultime",
    "Fascicule 101 — la religion véritable",
    "Fascicule 196 — l'héritage de Jésus",
  ],
  en: [
    "The Thought Adjuster",
    "Havona (central universe)",
    "The 7 superuniverses",
    "Michael of Nebadon",
    "The Paradise Trinity",
    "The 7 Master Spirits",
    "The life of Jesus (Part IV)",
    "Lucifer and the rebellion",
    "The Morontia (survival)",
    "The Supreme and the Ultimate",
    "Paper 101 — true religion",
    "Paper 196 — Jesus's legacy",
  ],
};

export default function Urantia() {
  return (
    <SacredChatPage
      persona="urantia"
      personaLabel="Livre d'Urantia"
      IconComponent={BookOpen}
      accent="#64a0ff"
      unlimited
      theme={{
        bgRadial: "radial-gradient(ellipse at top, #0a1a3a 0%, #050d22 55%, #020613 100%)",
        fg: "#e8f0ff",
        msgBg: "linear-gradient(180deg, rgba(10,22,56,0.92), rgba(4,10,24,0.95))",
        msgFg: "#c9d8f5",
      }}
      title={{
        fr: <>Voix du <span className="italic" style={{ color: "#64a0ff" }}>Livre d'Urantia</span>.</>,
        en: <>Voice of the <span className="italic" style={{ color: "#64a0ff" }}>Urantia Book</span>.</>,
      }}
      subtitle={{
        fr: "Recueil cosmologique de 1955 — 2097 pages structurées en 4 Parties. Je t'enseigne la cosmologie urantienne (Havona, Nébadon, l'Ajusteur de Pensée) comme un professeur de théologie comparée : avec rigueur, et en semant un doute constructif. Gratuit et illimité.",
        en: "1955 cosmological book — 2097 pages in 4 Parts. I teach you Urantian cosmology (Havona, Nebadon, the Thought Adjuster) like a professor of comparative theology: with rigor, and planting constructive doubt. Free and unlimited.",
      }}
      greeting={{
        fr: "« Ferme un instant les yeux. Ton Ajusteur de Pensée écoute déjà. Que veux-tu étudier ? »",
        en: "\"Close your eyes for a moment. Your Thought Adjuster is already listening. What do you want to study?\"",
      }}
      suggestions={{
        fr: [
          "Qu'est-ce que l'Ajusteur de Pensée ?",
          "Explique-moi la structure de Havona.",
          "Qui est Michel de Nébadon ?",
          "Comment distinguer peur et discernement ?",
        ],
        en: [
          "What is the Thought Adjuster?",
          "Explain the structure of Havona.",
          "Who is Michael of Nebadon?",
          "How to tell fear apart from discernment?",
        ],
      }}
      playlist={PLAYLISTS.urantia}
      lessonMode={{
        endpoint: "/chat/urantia/lesson",
        title: {
          fr: "Choisis un sujet urantien",
          en: "Pick a Urantian topic",
        },
        topics: LESSON_TOPICS,
      }}
    />
  );
}
